import hua from '@hweb/hua-js';
import Track from '@hweb/dataranges-log';
import { finderAppid } from '../../universalPages/Api.env.config';
import { getUrlQuery } from '@common/utils/token';
import { getCookieAndWindow } from '@common/utils/utils';

const platform = hua.getClientPlatform();
{
  let hotelId = getUrlQuery('hotelId');
  hotelId = hotelId || getCookieAndWindow('hotelId');
  const _param = getUrlQuery('param');
  const mac = getCookieAndWindow('mac') || '';
  const uuid = getUrlQuery('uuid') || getCookieAndWindow('gateway_uuid') || '';


  if (window.DATAFLUX_LOGS) {
    window.DATAFLUX_LOGS.onReady(() => {
      if (window.DATAFLUX_LOGS.setGlobalContextProperty) {
        window.DATAFLUX_LOGS.setGlobalContextProperty('service_common_protal_param', _param || '');
        window.DATAFLUX_LOGS.setGlobalContextProperty('hotelId', hotelId || '');
        window.DATAFLUX_LOGS.setGlobalContextProperty('mac', mac || '');
        window.DATAFLUX_LOGS.setGlobalContextProperty('service_common_portal_platform', platform || '');
        window.DATAFLUX_LOGS.setGlobalContextProperty('uuid', uuid || '');
      }
    })
  }
  

  
  window.HUD && window.HUD.setGlobalAttrs({
    service_common_protal_param: _param || '',
    service_common_protal_hotel_id: hotelId,
    hotelId: hotelId,
    service_common_protal_mac: mac,
    mac: mac,
    service_common_portal_platform: platform,
    service_common_portal_uuid: uuid,
    uuid: uuid,
  });

}



Track.loadDataRangeSdk().then(() => {
  const _param = getUrlQuery('param');
  let hotelId = getUrlQuery('hotelId');
  let hzPortalVer = getUrlQuery('hzPortalVer');
  hotelId = hotelId || getCookieAndWindow('hotelId');
  let mac = getCookieAndWindow('mac');
  const uuid = getUrlQuery('uuid') || getCookieAndWindow('gateway_uuid') || '';

  Track.onEvent('config', {
    service_common_protal_param: _param || '',
    service_common_protal_hotel_id: hotelId,
    hotelId: hotelId,
    service_common_protal_mac: mac,
    mac: mac,
    service_common_portal_platform: platform,
    service_common_portal_uuid: uuid,
    uuid: uuid,
  });
});

Track.init({
  app_id: +finderAppid, // 业务appid必填
}).then(() => {
  // SDK 初始化前的设置可能被忽略，初始化后重新应用当前设备身份或清除旧会员身份。
  instance.setUserUniqueID(instance.userId);
});


export class ServiceTrack {
  static _instance = null;

  constructor() {
    // 仅保存在当前页面上下文，不使用历史 memberId 或生成临时设备身份。
    this.userId = '';
    this.baseParmas = {
    };
  }

  static getInstance() {
    if (!this._instance) {
      this._instance = new ServiceTrack();
    }
    return this._instance;
  }

  globalConfig = (obj = {}) => {
    // 页面提供当前 MAC 时，在后续事件上报前同步用户身份，包含扫码目标设备场景。
    if (Object.prototype.hasOwnProperty.call(obj, 'mac')) {
      this.setUserUniqueID(obj.mac);
    }
    window.HUD && window.HUD.setGlobalAttrs({
      ...obj,
    })

  if (window.DATAFLUX_LOGS) {
    window.DATAFLUX_LOGS.onReady(() => {
      if (window.DATAFLUX_LOGS.setGlobalContextProperty) {
        for (let key in obj) {
          window.DATAFLUX_LOGS.setGlobalContextProperty(key, obj[key] || '');

        }
      }
    })
  }



    
    Track.onEvent('config', {
      ...obj,
    })

  }

  config = (obj = {}) => {
    for (const k in obj) {
      this.baseParmas[k] = obj[k];
      
    }
  };

  onEvent(eventId, param, beconEvent = false) {
    let screenWidth = 0;
    let screenHeight = 0;
    if (window.screen) {
      screenWidth = window.screen.width;
      screenHeight = window.screen.height;
    }

    const { innerWidth, innerHeight } = window;    
    
    const _curProps = {
      service_common_portal_screenWidth: screenWidth,
      service_common_portal_screenHeight: screenHeight,
      service_common_portal_innerWidth: innerWidth,
      service_common_portal_innerHeight: innerHeight,
      ...this.baseParmas,
      ...param,
    };

    this.HUD_track(eventId, _curProps)
    this.logData(eventId, _curProps)
    if (beconEvent) {
      Track.beconEvent(eventId, _curProps);
    } else {
      Track.onEvent(eventId, _curProps);
    }

  }

  // 埋点用户标识统一使用门户设备 MAC；MAC 不存在时清除旧身份，交由 SDK 匿名统计。
  setUserUniqueID = (mac) => {
    const userId = typeof mac === 'string' ? mac.trim() : '';
    this.userId = userId === 'null' || userId === 'undefined' ? '' : userId;
    if (this.userId) {
      Track.setUserUniqueID(this.userId);
      window.HUD && window.HUD.setUserId(this.userId);
    } else {
      Track.clearUserUniqueID();
      if (window.HUD && typeof window.HUD.clearUserId === 'function') {
        window.HUD.clearUserId();
      }
    }
  };


  logData = (eventId ,param, logType = 'info') => {
    const _curProps = {
      log_name: eventId,
      ...this.baseParmas,
      ...param,
      product: 'sixhs'
    };

    // if (window.DATAFLUX_RUM && window.DATAFLUX_RUM.getGlobalContext) {
    //   const _commonProps = window.DATAFLUX_RUM.getGlobalContext();
    //   for (let k in _commonProps) {
    //     if (_commonProps[k]) {
    //       _curProps[k] = _commonProps[k];
    //     }
    //   }
    // }

    if (window.HUD) {
      if (logType == 'info') {
        window.HUD.info(eventId, _curProps);
      }
      if (logType == 'warn') {
        window.HUD.warn(eventId, _curProps);
      }
      if (logType == 'error') {
        window.HUD.error(eventId, _curProps);
      }
    }
    
  }

  HUD_warn = (eventId, param) => {
    this.logData(eventId, param, 'warn')
  };

  HUD_info = (eventId, param) => {
    this.logData(eventId, param, 'info')

  };

  HUD_error = (eventId, param) => {
    this.logData(eventId, param, 'error')

  };

  HUD_track = (eventId, param) => {
    window.HUD && window.HUD.track(eventId, param);
  };
}

const instance = new ServiceTrack();

export const track = instance;
